import { z } from "zod";

const zSchema = z.object({
  id: z.string().uuid(),
  name: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 6),
  description: z.string().max(2 ** 8),
});
type Schema = z.infer<typeof zSchema>;

const zFlatSchema = z.enum(["ADMINISTRATOR", "EMPLOYEE", "USER"]);
const FlatSchema = zFlatSchema.Enum;
type FlatSchema = z.infer<typeof zFlatSchema>;

const zFlatRoleByRoleId = z.record(zSchema.shape.id, zFlatSchema);
type FlatRoleByRoleId = z.infer<typeof zFlatRoleByRoleId>;

export { FlatSchema, zFlatRoleByRoleId, zFlatSchema, zSchema };
export type { FlatRoleByRoleId, Schema };
